











































































































import QuizBase from "@tt-app/components/exercise/QuizBase";
import { AudioPreloader, getAuthInfo } from "@tt-app/utils";
import { ExerciseType, FooterState, Trophy } from "@tt-app/models";
import { api } from "@tt-app/api";
import { EXERCISE_TYPE } from "@tt-app/constants";
import { AudioData } from "@tt-app/types";
import {
  Session,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import { audioContext } from "@tt-app/utils/audio/audioContext";

import AssignmentCompletionModal from "@tt-app/components/assignment/AssignmentCompletionModal.vue";
import ExerciseHeaderTitle from "@tt-app/components/exercise/ExerciseHeaderTitle.vue";
import FeedbackPopup from "@tt-app/components/feedback/FeedbackPopup.vue";
import ImageCard from "@tt-app/components/exercise/common/ImageCard.vue";
import LayoutExercise from "@tt-app/layouts/LayoutExercise.vue";
import ListeningAudio from "@tt-app/components/quiz/ListeningAudio.vue";
import ListeningCard from "@tt-app/components/quiz/ListeningCard.vue";
import ListeningHtmlText from "@tt-app/components/quiz/ListeningHtmlText.vue";
import ListeningMultipleChoice from "@tt-app/components/quiz/ListeningMultipleChoice.vue";
import ListeningReview from "@tt-app/components/quiz/ListeningReview.vue";

import IconChevronLeft from "@joyz/app-core/assets/icons/default/ChevronLeft.svg";
import IconChevronLeftDisabled from "@joyz/app-core/assets/icons/transparent/ChevronLeft.svg";
import IconChevronRight from "@joyz/app-core/assets/icons/default/ChevronRight.svg";
import IconChevronRightDisabled from "@joyz/app-core/assets/icons/transparent/ChevronRight.svg";
import IconPlay from "@joyz/app-core/assets/icons/default/Play.svg";
import IconPlayDisabled from "@joyz/app-core/assets/icons/transparent/Play.svg";
import IconRewind from "@joyz/app-core/assets/icons/default/Rewind.svg";
import IconRewindDisabled from "@joyz/app-core/assets/icons/transparent/Rewind.svg";
import IconSelection from "@joyz/app-core/assets/icons/default/Selection.svg";
import AuthInstructions from "@tt-app/components/user/auth/AuthInstructions.vue";

type IconNames = "first" | "next" | "previous";

type Icons = {
  [name in IconNames]: string;
};

interface Data {
  animationDirection: string;
  answers: any;
  answerSubmitted: boolean;
  audioData: AudioData;
  audioDecoderPlayer: AudioDecoderPlayer;
  course?: any;
  chapter?: any;
  currentPageIndex: number;
  currentQuestionIndex: number;
  exercise?: {
    header?: {};
    pages?: any[];
  };
  exerciseResult: any;
  exerciseType: ExerciseType;
  feedbackFormVisible: boolean;
  icons: {
    active: Icons;
    disabled: Icons;
  };
  logId?: number;
  nav: {
    requireExitConfirmation: boolean;
  };
  review: any;
  section?: any;
  selectedOptions: any;
  showQuestionUI: boolean;
}

interface Methods {
  component: (componentConfig: any) => string;
  endExercise: () => void;
  handleFeedbackClose: () => void;
  handleFinalIconClick: () => void;
  handleNextIconClick: () => void;
  handlePreviousIconClick: () => void;
  logExerciseResponse: () => void;
  preloadAudioData: () => void;
  refreshAudioPlayer: () => void;
  scrollToTop: () => void;
  selectAnswer: (selectedAnswerIndex: number, problemUuid: string) => void;
  startExercise: () => void;
  toggleQuestionUI: () => void;
}

interface Computed {
  accuracy: any;
  body: any;
  currentPage: any;
  currentProblemsAnswered: boolean;
  currentProblemUuids: string[];
  currentQuestion: any;
  footer: any;
  finalQuestion: any;
  header: any;
  iconFinal: string;
  iconNext: string;
  iconNextDisabled: boolean;
  iconPrevious: string;
  iconPreviousDisabled: boolean;
  isReview: boolean;
  limitedModeActive: boolean;
  pageFinalQuestion: boolean;
  pageFirstQuestion: boolean;
  questions: any[];
  session: Session;
  showFeedbackForm: boolean;
  selectedAnswerIndex?: number;
  submitButtonDisabled: boolean;
  submitButtonText: string;
  allProblemUuids: string[];
  trophy?: Trophy;
}

export default QuizBase.extend<Data, Methods, Computed>({
  name: "QuizListening",
  components: {
    AuthInstructions,
    AssignmentCompletionModal,
    FeedbackPopup,
    ExerciseHeaderTitle,
    ImageCard,
    LayoutExercise,
    ListeningAudio,
    ListeningCard,
    ListeningHtmlText,
    ListeningMultipleChoice,
    ListeningReview
  },
  created() {
    document.addEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  beforeDestroy() {
    this.audioDecoderPlayer?.destroy();
    document.removeEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  data() {
    return {
      animationDirection: "slide-fade-previous",
      answers: {},
      answerSubmitted: false,
      audioData: {},
      audioDecoderPlayer: new AudioDecoderPlayer({ audioContext }),
      course: {},
      currentPageIndex: 0,
      currentQuestionIndex: 0,
      exercise: {},
      exerciseResult: undefined,
      exerciseType: EXERCISE_TYPE.QUIZ_LISTENING,
      feedbackFormVisible: true,
      icons: {
        active: {
          final: IconPlay,
          first: IconRewind,
          next: IconChevronRight,
          previous: IconChevronLeft
        },
        disabled: {
          final: IconPlayDisabled,
          first: IconRewindDisabled,
          previous: IconChevronLeftDisabled,
          next: IconChevronRightDisabled
        },
        selection: IconSelection
      },
      logId: undefined,
      nav: {
        requireExitConfirmation: true
      },
      review: {},
      selectedOptions: {},
      showQuestionUI: false
    };
  },
  computed: {
    accuracy() {
      let numCorrectAnswers = 0;
      let numIncorrectAnswers = 0;

      const answers = this.answers;

      Object.values(answers).forEach((answer: any) => {
        if (answer.isCorrect) {
          numCorrectAnswers += 1;
        } else {
          numIncorrectAnswers += 1;
        }
      });

      return {
        numCorrectAnswers,
        numIncorrectAnswers
      };
    },
    body() {
      if (!this.currentPage) {
        return undefined;
      }

      return this.currentPage.body.filter((element: any) => {
        return !element.problemUuid;
      });
    },
    currentPage() {
      return (
        (this.exercise && this.exercise.pages && this.exercise.pages[this.currentPageIndex]) ||
        undefined
      );
    },
    currentProblemUuids() {
      return this.currentPage.body.filter((component: any) => {
        return component.type === "TEXT_SINGLE_SELECTION";
      });
    },
    currentProblemsAnswered() {
      const currentPage = this.currentPage;

      if (!currentPage) {
        return false;
      }

      const problems = currentPage.body.filter((component: any) => {
        return component.type === "TEXT_SINGLE_SELECTION";
      });

      return problems.every((problem: any) => {
        return Object.keys(this.selectedOptions).includes(problem.problemUuid);
      });
    },
    currentQuestion() {
      if (!this.questions) return undefined;

      return this.questions[this.currentQuestionIndex];
    },
    finalQuestion() {
      if (!this.currentPage) {
        return false;
      }

      const nextPage = this.exercise.pages[this.currentPageIndex + 1];

      return !!(nextPage && nextPage.body[0].type === "REVIEW");
    },
    footer() {
      if (!this.currentPage) {
        return {};
      }

      let footerDefinition: FooterState = {
        buttons: [],
        disabled: false,
        show: false
      };

      if (this.isReview) {
        footerDefinition = this.review.footer[0];

        const buttons = footerDefinition.buttons;

        const nextExerciseButton = buttons.find(button => {
          return button.action === "NEXT_EXERCISE";
        });

        if (nextExerciseButton) {
          nextExerciseButton.text = this.nextExerciseButtonText;
        }

        footerDefinition = {
          ...footerDefinition,
          show: true
        };
      }

      return footerDefinition;
    },
    header() {
      return {
        courseTitle: this.course.title,
        chapterTitle: this.chapter?.title,
        exerciseTitle: this.exercise.title,
        sectionTitle: this.section?.title
      };
    },
    iconFinal() {
      return this.iconNextDisabled ? this.icons.disabled.first : this.icons.active.first;
    },
    iconNext() {
      return this.pageFinalQuestion ? this.icons.disabled.next : this.icons.active.next;
    },
    iconNextDisabled() {
      return Boolean(this.pageFinalQuestion);
    },
    iconPrevious() {
      return this.iconPreviousDisabled ? this.icons.disabled.previous : this.icons.active.previous;
    },
    iconPreviousDisabled() {
      return Boolean(this.pageFirstQuestion);
    },
    isReview() {
      if (!this.currentPage) return false;

      return this.currentPage.body[0].type === "REVIEW";
    },
    limitedModeActive() {
      return Boolean(this.session?.limitedMode?.id);
    },
    pageFirstQuestion() {
      return this.currentQuestionIndex === 0;
    },
    pageFinalQuestion() {
      /**
       * if the current question index is 1 more than the questions array length
       * we want to show the `next question` or `view results` button. That is
       * why this isn't `this.questions.length - 1`
       */
      return this.currentQuestionIndex === this.questions.length;
    },
    session() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];
    },
    showFeedbackForm() {
      return this.feedbackFormVisible && this.isReview;
    },
    submitButtonDisabled() {
      return !this.currentProblemsAnswered || this.answerSubmitted;
    },
    submitButtonText() {
      return this.finalQuestion
        ? this.$__("exercise.action.review")
        : this.$__("exercise.action.next");
    },
    allProblemUuids() {
      const allBodies = this.exercise.pages.reduce((accumulator: any, element: any) => {
        return [...accumulator, ...element.body];
      }, []);

      return allBodies.flatMap((element: any) => {
        return element.type === "TEXT_SINGLE_SELECTION" ? [element.problemUuid] : [];
      });
    },
    questions() {
      if (!this.body) return [];

      return this.currentPage.body.filter((question: any) => {
        return Boolean(question.problemUuid);
      });
    },
    trophy() {
      if (!this.exerciseResult) {
        return undefined;
      }
      const { numIncorrectAnswers, numCorrectAnswers } = this.accuracy;

      const trophyComments: { [key: string]: string } = {
        3: "ex.trophy.gold",
        2: "ex.trophy.silver",
        1: "ex.trophy.bronze"
      };

      const comment = this.$__(
        trophyComments[this.exerciseResult.trophy],
        this.exerciseResult.moreCorrectAnswers
      );

      return {
        comment,
        correctCount: numCorrectAnswers,
        incorrectCount: numIncorrectAnswers,
        score: this.exerciseResult.trophy
      };
    }
  },
  methods: {
    component(componentConfig) {
      const components = {
        AUDIO: "listening-audio",
        CHAT_TEXT: "listening-card",
        HTML_TEXT: "listening-html-text",
        IMAGE: "image-card",
        TEXT_SINGLE_SELECTION: "listening-multiple-choice",
        REVIEW: "listening-review"
      };

      const {
        type
      }: {
        type: "AUDIO" | "CHAT_TEXT" | "HTML_TEXT" | "IMAGE" | "TEXT_SINGLE_SELECTION" | "REVIEW";
      } = componentConfig;

      return components[type];
    },
    async endExercise() {
      const authInfo = await getAuthInfo(this.$store.getters);

      const params = {
        ...authInfo,
        logId: this.logId,
        ...this.accuracy,
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType
      };

      const response: any = await api.exercise.endExercise(params);
      const { reviewPage, ...results } = response;

      this.review = reviewPage;
      this.exerciseResult = results;
      this.nav.requireExitConfirmation = false;
    },
    handleFeedbackClose() {
      this.feedbackFormVisible = false;
    },
    async logExerciseResponse() {
      this.answerSubmitted = true;

      const authInfo = await getAuthInfo(this.$store.getters);

      const requests = this.currentProblemUuids.map(({ problemUuid }: any) => {
        const params = {
          logId: this.logId,
          problemUuid,
          answer: this.selectedOptions[problemUuid].id,
          assignmentId: Number(this.assignmentId) || undefined,
          courseUuid: this.$route.params.courseUuid,
          exerciseUuid: this.$route.params.exerciseUuid,
          exerciseType: this.exerciseType
        };

        const payload: any = {
          ...authInfo,
          ...params
        };

        return api.exercise.submitAnswer(payload).then((response: any) => {
          return {
            problemUuid,
            ...response
          };
        });
      });

      const responses = await Promise.all(requests);

      responses.forEach(response => {
        this.answers = {
          ...this.answers,
          [response.problemUuid]: {
            correctId: response.correctId,
            isCorrect: response.isCorrect
          }
        };
      });

      if (this.finalQuestion) {
        await this.endExercise();
      }
    },
    async preloadAudioData() {
      const audioPreloader = new AudioPreloader(this.exercise, this.audioData);
      await audioPreloader.downloadAudioData();
    },
    refreshAudioPlayer() {
      if (document.visibilityState === "visible") {
        console.log("refreshing audio player");
        this.audioDecoderPlayer = new AudioDecoderPlayer({ audioContext });
      }
    },
    scrollToTop() {
      const container = document.getElementById("drill-contents");
      container && container.scrollTo(0, 0);
    },
    selectAnswer(selectedOption: any, problemUuid: any) {
      const newOptions = {
        ...this.selectedOptions,
        [problemUuid]: selectedOption
      };

      this.selectedOptions = newOptions;

      setTimeout(() => {
        this.handleNextIconClick();
      }, 300);
    },
    handleFinalIconClick() {
      if (!this.showQuestionUI) {
        this.showQuestionUI = true;
        return;
      }

      this.animationDirection = "slide-fade-next";

      this.currentQuestionIndex = this.questions.length;
    },
    handleNextIconClick() {
      if (!this.showQuestionUI) {
        this.showQuestionUI = true;
        return;
      }

      if (this.currentQuestionIndex + 1 >= this.questions.length + 1) return;

      this.animationDirection = "slide-fade-next";

      this.currentQuestionIndex += 1;
    },
    handlePreviousIconClick() {
      if (!this.showQuestionUI) {
        this.showQuestionUI = true;
        return;
      }

      if (this.currentQuestionIndex - 1 < 0) return;

      this.animationDirection = "slide-fade-previous";

      this.currentQuestionIndex -= 1;
    },
    async startExercise() {
      const authInfo = await getAuthInfo(this.$store.getters);
      const details = {
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType,
        limitedModeId: this.session?.limitedMode?.id,
        sessionId: this.session?.id
      };

      const apiPayload = { ...authInfo, ...details };

      const response: any = await api.exercise.startExercise(apiPayload);

      this.logId = response.logId;
      this.nav.requireExitConfirmation = true;
    },
    toggleQuestionUI() {
      this.showQuestionUI = !this.showQuestionUI;
    }
  },
  watch: {
    exercise() {
      this.startExercise();

      this.preloadAudioData();
    }
  }
});
